import Vue from 'vue';

export default function() {
	Vue.$ofsCrud.addResource({
		name: 'production-order',
		pluralName: 'production-orders',
		transport: 'davinci',
		options: {
			namespaced: true
		},
		actions: {
			async getListOfAvailablePSPs({ dispatch }, id) {
				const payload = {
					path: `production-orders/${id}/available-psps`,
					method: 'GET'
				};
				const response = await dispatch('request', payload);
				return response.data;
			}
		}
	});
}
